import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Divider, Drawer, Toolbar } from 'react-md';
import { withStyles } from '@material-ui/core/styles';
import { compact, map, isEqual } from 'lodash-es';

import CheckBoxesFilter from './CheckBoxesFilter';
import TextFilter from './TextFilter';

import './FilterControls.scss';

class FilterControls extends Component {
  state = {
    visible: false,
    position: 'right',
  };

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { filters: nextFilters, filtersUI: nextFiltersUI } = nextProps;
    const { filters: prevFilters, filtersUI: prevFiltersUI } = prevState;
    let newState = null;

    if (!isEqual(prevFilters, nextFilters)) {
      newState = {
        filters: nextFilters,
      };
    }

    if (!isEqual(prevFiltersUI, nextFiltersUI)) {
      newState = { ...newState, filtersUI: prevFiltersUI };
    }

    return newState;
  }

  componentDidMount() {
    const { filters } = this.props;

    this.setState({
      filters,
    });
  }

  openDrawerRight = () => {
    this.setState({ visible: true, position: 'right' });
  };

  closeDrawer = () => {
    this.setState({ visible: false });
  };

  handleVisibility = visible => {
    this.setState({ visible });
  };

  // ----
  handleChange = ({ values, name }) => {
    const { onFiltersChange } = this.props;
    const { filters } = this.state;
    const newFilters = { ...filters, [name]: values };
    this.setState({
      filters: newFilters,
    });
    onFiltersChange(newFilters);
  };

  render() {
    const { strings, classes, filtersUI } = this.props;
    const { filters } = this.state;

    const { visible, position } = this.state;
    const isLeft = position === 'left';

    const closeBtn = (
      <Button icon onClick={this.closeDrawer}>
        {isLeft ? 'arrow_back' : 'close'}
      </Button>
    );

    const getFilters = () => {
      const filtersList = compact(
        map(filtersUI, (filter, name) => {
          switch (filter.type) {
            case 'checkbox':
              return (
                <Fragment key={name}>
                  <CheckBoxesFilter
                    label={filter.label}
                    name={name}
                    options={filter.options}
                    values={filters[name]}
                    classes={classes}
                    onFilterChange={this.handleChange}
                  />
                  <Divider style={{ marginBottom: '1.5em' }} />
                </Fragment>
              );

            case 'text':
              return (
                <Fragment key={name}>
                  <TextFilter
                    label={filter.label}
                    placeholder={filter.placeholder}
                    value={filters[name]}
                    defaultValue={filter.value}
                    classes={classes}
                    onFilterChange={this.handleChange}
                    icon={filter.icon}
                    name={name}
                  />
                  <Divider style={{ marginBottom: '1.5em' }} />
                </Fragment>
              );

            default:
              return null;
          }
        })
      );
      return filtersList;
    };

    // eslint-disable-next-line no-unused-vars
    const filtersBlock = (
      <div className={classes.root} style={{ padding: '1em', display: 'flex', flexDirection: 'column' }}>
        {getFilters()}
      </div>
    );

    const toolbar = (
      <Toolbar
        title={
          strings['quotations.filter.label'] ||
          strings['contracts.filter.label'] ||
          strings['parties.filter.label'] ||
          strings['product.filter.label'] ||
          strings['salesroutes.filter.label'] ||
          'Filters'
        }
        nav={isLeft ? null : closeBtn}
        actions={isLeft ? closeBtn : null}
        className="md-divider-border md-divider-border--bottom"
      />
    );

    return (
      <>
        <div className="filter-block">
          {/* <Button raised onClick={this.openDrawerRight}>
            Filters
            </Button> */}
          <Button
            onClick={this.openDrawerRight}
            flat
            primary
            iconChildren="filter_list"
            iconBefore={false}
            // mini
          >
            {strings['quotations.filter.label'] ||
              strings['contracts.filter.label'] ||
              strings['parties.filter.label'] ||
              strings['product.filter.label'] ||
              strings['salesroutes.filter.label'] ||
              'Filters'}
          </Button>
        </div>
        {/* <Button
          onClick={this.openDrawerRight}
          floating
          //   primary
          mini
          style={{
            position: 'absolute',
            right: '20px',
            top: '20px',
            flexGrow: '0',
            zIndex: '2'
          }}
        >
}
          filter_list
        </Button> */}
        <Drawer
          id="filter-drawer"
          type={Drawer.DrawerTypes.TEMPORARY}
          visible={visible}
          position={position}
          onVisibilityChange={this.handleVisibility}
        >
          {toolbar}
          {filtersBlock}
        </Drawer>
      </>
    );
  }
}

FilterControls.propTypes = {
  onFiltersChange: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  // see https://github.com/facebook/prop-types/issues/183
  // filters: PropTypes.objectOf(PropTypes.object),
  // eslint-disable-next-line react/forbid-prop-types
  filters: PropTypes.object,
  filtersUI: PropTypes.objectOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.any]).isRequired,
      label: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
          label: PropTypes.string.isRequired,
        })
      ),
      type: PropTypes.oneOf(['checkbox', 'select', 'text']),
    })
  ),
};

FilterControls.defaultProps = {
  onFiltersChange: params => {
    // eslint-disable-next-line no-console
    console.log('onFiltersChange', params);
  },
  filters: {
    query: '',
    status: [],
    commercialProductId: [],
  },
  filtersUI: {
    query: {
      value: '',
      label: 'Filter by Id or Subscriber',
      placeholder: 'eg. Paul Smith or 34G78... ',
      type: 'text',
      name: 'query',
    },
    status: {
      value: [],
      options: [
        {
          label: 'Submitted',
          value: 'submitted',
        },
        {
          label: 'Project',
          value: 'project',
        },
        {
          label: 'Canceled',
          value: 'canceled',
        },
        {
          label: 'Pending',
          value: 'pending',
        },
      ],
      label: 'Filter by Status',
      name: 'status',
      type: 'checkbox',
    },
    commercialProductId: {
      value: {
        name: undefined,
        id: undefined,
      },
      options: [
        {
          label: 'Habitation +',
          value: '1',
        },
        {
          label: 'Prévoyance +',
          value: '2',
        },
        {
          label: 'Emprunteur +',
          value: '3',
        },
        {
          label: 'Obsèques +',
          value: '4',
        },
        {
          label: 'Prevoyance Co +',
          value: '5',
        },
      ],
      label: 'Filter by Product',
      name: 'commercialProductId',
      type: 'checkbox',
    },
  },
};

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 600,
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.25),
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
});

export default withStyles(styles, { withTheme: true })(FilterControls);
